<template>
    <div>
        <div class="column box" style="overflow-x:auto;  min-height: 700px">
            <div class="column search">
                <div class="field has-addons is-pulled-left">
                    <div class="control">
                        <input class="input is-normal" type="text" v-model="searchText" placeholder="Find a Notify" @keyup="fillsearchField()">
                    </div>
                    <div class="control">
                        <a class="button">
                            <font-awesome-icon class="is-size-5 color-default" icon="search"/>
                        </a>
                    </div>
                </div>
            </div>
            <div class="columns"  style="justify-content: right;">
                <div class="column has-text-right">
                    <div class="tooltip"><font-awesome-icon class="is-size-5 is-warning" icon="info"/>
                        <div class="tooltiptext">
                            <ul style="list-style: disc outside">
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">Integration you can access the EFF Transfer tool work history.</p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can sort notification by Pro Time, Versio, FKeyForZip, Notify Type ID, Notify Type, Notify Stat,
                                        Notify Region, First Notify, Last Notify, Notify Text
                                    </p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can search notification by Versio, FKeyForZip, Notify Type ID, Notify Type, Notify Stat, Notify Region
                                        Notify Region, First Notify, Last Notify, Notify Text
                                    </p>
                                </li>
                                <li style="margin-left: 20px">
                                    <p style="margin-bottom: 10px">You can examine Notification on the Grid.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <table class="table is-fullwidth">
                <thead>
                <tr>
                    <th>
                        <button class="t-sort"
                                @click="sortBy('proTime')">Pro Time
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'proTime' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'proTime')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort"
                                @click="sortBy('versionCount')">Versio
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'versionCount' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'versionCount')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort"
                                @click="sortBy('fKeyForZip')">FKeyForZip
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'fKeyForZip' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'fKeyForZip')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort"
                                @click="sortBy('notifyTypeId')">Notify Type ID
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'notifyTypeId' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'notifyTypeId')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort"
                                @click="sortBy('notifyType')">Notify Type
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'notifyType' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'notifyType')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort"
                                @click="sortBy('notifyStat')">Notify Stat
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'notifyStat' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'notifyStat')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort"
                                @click="sortBy('notifyRegion')">Notify Region
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'notifyRegion' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'notifyRegion')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort"
                                @click="sortBy('firstNotifyDt')">First Notify
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'firstNotifyDt' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'firstNotifyDt')"/>
                        </button>
                    </th>
                    <th>
                        <button class="t-sort"
                                @click="sortBy('lastNotifyDt')">Last Notify
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'lastNotifyDt' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'lastNotifyDt')"/>
                        </button></th>
                    <th>
                        <button class="t-sort"
                                @click="sortBy('notifyText')">Notify Text
                            <font-awesome-icon class="sort-icon"
                                               :class="sort === 'notifyText' ? 'icon-color-white' : 'icon-color-default'"
                                               :icon="iconSort(sortDir, 'notifyText')"/>
                        </button>
                    </th>
                </tr>
                </thead>
                <tbody v-if="paginate && paginate.length">
                <template v-for="notify in paginate">
                    <tr :class="CalculateStatColor(notify.notifyType, notify.notifyText)" :key="notify.id">
                        <!--              :class="[ notify.NotifyType === 'nt03Warning' ?  (notify.NotifyText !== '' ? 'bg-warning' : 'bg-white') : (notify.NotifyText !== '' ? 'bg-danger' : 'bg-white') ]">-->
                        <td :class="sort === 'proTime' ? 'bg-sort-selected' : ''">{{ notify.proTime |longFormatDateFromString}}</td>
                        <td :class="sort === 'versionCount' ? 'bg-sort-selected' : ''">{{ notify.versionCount }}</td>
                        <td :class="sort === 'fKeyForZip' ? 'bg-sort-selected' : ''">{{ notify.fKeyForZip }}</td>
                        <td :class="sort === 'notifyTypeId' ? 'bg-sort-selected' : ''">{{ notify.notifyTypeId }}</td>
                        <td :class="sort === 'notifyType' ? 'bg-sort-selected' : ''">{{ notify.notifyType }}</td>
                        <td :class="sort === 'notifyStat' ? 'bg-sort-selected' : ''">{{ notify.notifyStat }}</td>
                        <td :class="sort === 'notifyRegion' ? 'bg-sort-selected' : ''">{{ notify.notifyRegion }}</td>
                        <td :class="sort === 'firstNotifyDt' ? 'bg-sort-selected' : ''">{{ notify.firstNotifyDt |longFormatDateFromString}}</td>
                        <td :class="sort === 'lastNotifyDt' ? 'bg-sort-selected' : ''">{{ notify.lastNotifyDt |longFormatDateFromString}}</td>
                        <td :class="sort === 'notifyText' ? 'bg-sort-selected' : ''">{{ notify.notifyText }}</td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <div class="">
            <div class="level" style="justify-content: center; margin-top: 20px">
                <nav class="pagination" role="navigation" aria-label="pagination">
                    <ul class="pagination-list">
                        <li v-if="pageNavigationInfo.hasFirstPageNavigation">
                            <div @click="setPage(1)" class="pagination-link bg-default color-default">
                                <font-awesome-icon class="is-size-5 color-default" icon="backward"/>
                            </div>
                        </li>
                        <li v-for="index in pageNavigationInfo.pageCount" :key="index">
                            <div :style="currentPage === pageNavigationInfo.start + index ? 'background-color:#6a85a7;' : 'background-color:#f8f6ff'" @click="setPage(pageNavigationInfo.start + index)" class="pagination-link">
                                <a :style="currentPage === pageNavigationInfo.start + index ? 'color:white;' : 'color:#6a85a7'" :class="[currentPage === pageNavigationInfo.start + index ? 'current':'']">{{
                                    pageNavigationInfo.start + index
                                    }}</a>
                            </div>
                        </li>
                        <li v-if="pageNavigationInfo.hasLastPageNavigation">
                            <div @click="setPage(pageNavigationInfo.total)" class="pagination-link bg-default color-default">
                                <font-awesome-icon class="is-size-5 color-default" icon="forward"/>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>
<style>
    .bg-danger {
        background-color: #feecf0;
        color: #cc0f35;
    }

    .bg-warning {
        background-color: #fffaeb;
        color: #946c00;
    }

    .bg-white {
        background: #ffffff;
    }


    .box {
        border-radius: 10px;
    }

    .last-error {
        color: red;
    }

    .border-right {
        border-right: 1px solid black;
    }

    th {
        border-right: 1px solid #ababab45;
        background-color: #6a85a7;
        color: white!important;
        min-width: 10.5rem;
    }

    .btn-color {
        background-color: #6a85a7;
        color: white;
    }

    .search{
        padding: 0;
        margin-bottom: 3em;
    }

    * {
        box-sizing: border-box;
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;
    }

    table tr th:last-child {
        border-right: none
    }

    table tr td {
        border-bottom: 1px solid #ababab45;
    }
    .table-center {
        text-align: -webkit-center !important;
    }

    .color-default {
        color: #6a85a7!important;
    }


    .search{
        padding: 0;
        margin-bottom: 3em;
    }
    .bg-white {
        background-color: white;
    }
    .bg-default {
        background-color: #f8f6ff !important;
    }
    .t-sort {
        border: none;
        background: transparent;
        color: white;
        font-weight: bold;
        font-size: 16px;
        cursor: pointer;
    }

    .sort-icon {
        margin-left: 5px;
        font-size: 18px;
        color: #ffffff69;
    }

    .icon-color-white {
        color: #ffffff;
    }

    .icon-color-default {
        color: #ffffff69;
    }

    .mt-4 {
        margin-top: 1rem;
    }

    .is-justify-content-center {
        justify-content: center;
    }
    .bg-sort-selected {
        background-color: #eae7f3!important;
        color: black;
    }

    @media (max-width: 1600px) {
        .cards {
            justify-content: center;
        }
    }

    .tooltip {
        position: relative;
        display: inline-block;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        min-width: 400px;
        max-width: 420px;
        background-color: #6a85a7de;
        border:3px solid;
        border-color: #4f4f4f;
        color: #fff;
        border-radius: 6px;
        top: 100%;
        left: 50%;
        margin-left: -366px;
        padding: 10px;
        margin-right: 23px;
        margin-top: 13px;
        font-size: 15px;
        text-align: left;

        /* Position the tooltip */
        position: absolute;
        z-index: 1111;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
    }

</style>
<script>
    import {mapActions} from "vuex";

    export default {
        name: "Notify2",
        components: {},
        data() {
            return {
                opened: [],
                searchText: "",
                tempSearch: "",
                notifyList: [],
                resultCount: 0,
                currentPage: 1,
                pageRange: 3,
                itemsPerPage: 20,
                pageNavigationInfo: {},
                isToggleActived: [],
                StatColorList: [
                    {
                        type: "nt03Warning",
                        class: "bg-warning"
                    },
                    {
                        type: "nt02Error",
                        class: "bg-danger"
                    },
                    {
                        type: "nt01Information",
                        class: "bg-white"
                    }
                ],
                iconList: [
                    {
                        type: true,
                        icon: "plus",
                    },
                    {
                        type: false,
                        icon: "minus",
                    },
                    {
                        type: "default",
                        icon: "sort",
                    },
                    {
                        type: "asc",
                        icon: "sort-up",
                    },
                    {
                        type: "desc",
                        icon: "sort-down",
                    }
                ],
                sort: 'id',
                sortDir: 'default'
            }
        },
        methods: {
            ...mapActions["getNotifyList"],
            async getNotifyList() {
                try {
                    this.notifyList = await this.$store.dispatch("notifies/getNotifications")
                } catch (e) {
                    //this.$notify({title: "Error", text:"Error on getNotifyList, "+ e.message, type: "error"});
                }
            },

            CalculateStatColor(notifyType, notifyText) {
                if (notifyText !== '' && notifyText !== undefined && notifyText !== null) {
                    return this.StatColorList.find(x => x.type === notifyType).class
                } else {
                    return 'bg-white'
                }
            },

            toggle(id) {
                const index = this.opened.indexOf(id);
                if (index > -1) {
                    this.opened.splice(index, 1)
                } else {
                    this.opened.push(id)
                }
            },
            setResultCount(count) {
                this.resultCount = count;
            },
            setCurrentPage(currentPage) {
                this.currentPage = currentPage;
            },
            setPage(pageNumber) {
                this.currentPage = pageNumber;
                this.buildPageNavigationInfo()
            },
            setNotifyList(list) {
                this.notifyList = list;
            },
            buildPageNavigationInfo() {
                let _total = this.totalPages;
                let _current = this.currentPage;

                let firstPage = Math.max(1, _current - this.pageRange);
                let lastPage = Math.min(_total, _current + this.pageRange);

                this.pageNavigationInfo = {
                    start: firstPage - 1,
                    end: lastPage,
                    hasFirstPageNavigation: firstPage > 1,
                    hasLastPageNavigation: lastPage < _total,
                    pageCount: lastPage - firstPage + 1,
                    total: _total,
                }
            },

            sortBy(sortName) {
                if (sortName === this.sort) {
                    this.sortDir = (this.sortDir === 'asc') ? 'desc' : 'asc';
                } else {
                    this.sortDir = 'asc';
                }
                this.sort = sortName;
            },

            iconSort(sort, name) {
                if (name === this.sort) {
                    return this.iconList.find(x => x.type === sort).icon
                } else {
                    return this.iconList.find(x => x.type === 'default').icon
                }
            },
            async fillsearchField() {
                setTimeout(() => this.tempSearch = this.searchText, 1000)
            },

        },
        async created() {
            await this.getNotifyList();
            this.currentPage = 1;
            this.buildPageNavigationInfo();
        },
        computed: {
            totalPages() {
                return Math.ceil(this.resultCount / this.itemsPerPage);
            },

            paginate() {
                if (!this.notifyList) {
                    return
                }
                this.setNotifyList(this.notifyList);

                let list = this.notifyList.filter((post) => {
                    return post.notifyType.toLowerCase().match(this.searchText.toLowerCase())
                        || post.notifyRegion.toLowerCase().match(this.searchText.toLowerCase())
                        || post.notifyStat.toString().match(this.searchText)
                        || post.notifyTypeId.toString().match(this.searchText)
                        || post.versionCount.toString().match(this.searchText)
                        || post.fKeyForZip.toString().match(this.searchText)
                    // || post.proTime.toLowerCase().match(this.searchText.toLowerCase())
                    // || post.firstNotifyDt.toLowerCase().match(this.searchText.toLowerCase())
                    // || post.lastNotifyDt.toLowerCase().match(this.searchText.toLowerCase())
                });



                this.setResultCount(list.length);
                if (this.currentPage === 0) this.setCurrentPage(1)
                if (this.currentPage >= this.totalPages) {
                    this.setCurrentPage(this.totalPages)
                }

                let index = this.currentPage * this.itemsPerPage - this.itemsPerPage

                this.buildPageNavigationInfo()
                return list.slice(index, index + this.itemsPerPage).sort((a, b) => {
                    let dir = (this.sortDir === 'asc') ? 1 : -1;
                    if (a[this.sort] < b[this.sort]) {
                        return -1 * dir;
                    } else if (a[this.sort] > b[this.sort]) {
                        return 1 * dir;
                    } else {
                        return 0;
                    }
                });


            },
            searchNotifyType(){
                if(this.search){
                    return this.paginate.filter((item)=>{
                        // this.search.toLowerCase().split(' ').every(v => item.NotifyType.toLowerCase().includes(v)) ||
                        return this.search.toLowerCase().split(' ').every(v => item.NotifyText.toLowerCase().includes(v))
                    })
                }else{
                    return this.paginate;
                }
            },

        },
        mounted() {
        }
    }
</script>
